module.exports = __webpack_public_path__ + "static/media/bg_africa.01ae1b3f.jpg";